import React, { useEffect, useRef, useState } from "react";

export const Services = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div id="services" ref={sectionRef}>
      <div className="container">
        <div className="section-title">
          <h2>Best Gold Buying Services in Guwahati</h2>
          <p>
            We buy all types of gold items at the highest market rates. From gold jewelry to coins, bars, and chains - get instant cash for your gold today!
          </p>
        </div>

        <div className="row">
          {props.data ? (
            props.data.map((d, i) => {
              let animationClass = "";

              // First 2 items (0, 1) - animate from left
              if (i < 2) {
                animationClass = "animate-from-left";
              }
              // Middle 2 items (2, 3) - no animation
              else if (i >= 2 && i < 4) {
                animationClass = "";
              }
              // Last 2 items (4, 5) - animate from right
              else if (i >= 4) {
                animationClass = "animate-from-right";
              }

              return (
                <div
                  key={`${d.name}-${i}`}
                  className={`col-md-4 col-sm-6 ${isVisible ? animationClass : ""}`}
                >
                  <div className="service-card">
                    <div className="service-image-container">
                      <img src={d.icon} alt={d.name} className="service-image" />
                      <div className="service-image-overlay"></div>
                    </div>
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <span>Loading...</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Services;